import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const GaelicHurling = () => {
  return (
    <SportsLayoutComp name={'Gaelic Hurling'}/>
  )
}

export default GaelicHurling